import dayjs from 'dayjs'

export const gatewayColumns = [
  {
    title: '网关',
    dataIndex: 'gatewayCode',
    width: 150,
    ellipsis: true
  },
  {
    title: '最新上线时间',
    dataIndex: 'lastOnlineTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  }, {
    title: '最新离线时间',
    dataIndex: 'lastOfflineTime',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: '1H内上线次数',
    dataIndex: 'count',
    width: 150,
    ellipsis: true
  }
]

export const gatewayAppColumns = [
  {
    title: '网关',
    dataIndex: 'gatewayCode',
    width: 150,
    ellipsis: true
  },
  {
    title: 'APP',
    dataIndex: 'appCode',
    width: 150,
    ellipsis: true
  }, {
    title: '5min内消息总量',
    dataIndex: 'messageTotal',
    width: 150,
    ellipsis: true
  },
  {
    title: '5min内消息总大小',
    dataIndex: 'messageSize',
    width: 150,
    ellipsis: true
  }
]

export const errInfoColumns = (fn) => ([
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: 80,
    ellipsis: true,
    customRender: (t, r) => fn(r)
  },
  {
    title: '触发时间',
    dataIndex: 'time',
    width: 150,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  },
  {
    title: '客户端',
    dataIndex: 'clientIp',
    width: 150,
    ellipsis: true,
    customRender: (t, r) => t ? t + ':' + r.clientPort : ''
  },
  {
    title: '服务端',
    dataIndex: 'serveIp',
    width: 150,
    ellipsis: true,
    customRender: (t, r) => t ? t + ':' + r.servePort : ''
  }, {
    title: '网关编号',
    dataIndex: 'deviceCode',
    width: 120,
    ellipsis: true
  },
  {
    title: 'APP',
    dataIndex: 'appId',
    width: 120,
    ellipsis: true
  },
  {
    title: '信息',
    dataIndex: 'friendlyMessage',
    width: 120,
    ellipsis: true
  },
  /*{
    title: '友好提示',
    dataIndex: 'friendlyMessage',
    width: 150,
    ellipsis: true
  }, */
  {
    title: '异常类型',
    dataIndex: 'exception',
    width: 160,
    ellipsis: true
  }, {
    title: '异常信息',
    dataIndex: 'exceptionMessage',
    width: 160,
    ellipsis: true
  }, {
    title: '堆栈信息',
    dataIndex: 'exceptionStackMsg',
    width: 160,
    ellipsis: true
  }
])

export const getNotOnlineColumns = [
  {
    title: '网关编号',
    dataIndex: 'gatewayCode',
    width: 160,
    ellipsis: true
  }, {
    title: '租户编号',
    dataIndex: 'tenantId',
    width: 100,
    ellipsis: true
  }, {
    title: '最后上线时间',
    dataIndex: 'lastOfflineTime',
    width: 160,
    ellipsis: true,
    customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
  }
]
